export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9499.66b7039c.jpg";